import initialProject from 'helpers/projects/initialProject'
import projectWithModel from 'sagas/setupProjectsSaga/projectWithModel'
import cameraWithModel from 'sagas/setupProjectsSaga/cameraWithModel'
import { expandProjectAction } from 'actions/projectActions'
import { put, call } from 'redux-saga/effects'
import { createOfflineManufacturerSpecificProject } from 'sagas/setupProjectsSaga/handleManufacturerSpecificProject'

export default function * handleOfflineProject({ model, manufacturer, active }) {
  const expandActionWithoutModel = expandProjectAction(initialProject(), true, active)

  if (model) {
    const camera = cameraWithModel(model)
    yield put(expandProjectAction(projectWithModel(camera), true, active))
  } else if (manufacturer) yield call(createOfflineManufacturerSpecificProject, manufacturer, active)
  else yield put(expandActionWithoutModel)
}



// WEBPACK FOOTER //
// ./src/sagas/setupProjectsSaga/handleOfflineProject.js